import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import { normalizeLocale } from '../../util/locales';

export const ASSET_NAME = 'landing-page';
export const GREEK_ASSET_NAME = 'landing-page-greek';
export const SPANISH_ASSET_NAME = 'landing-page-spanish';

export const loadData = (params, search, config, lang) => async dispatch => {
  const locale = normalizeLocale(lang);
  const assetName =
    locale === 'el' ? GREEK_ASSET_NAME : locale === 'es' ? SPANISH_ASSET_NAME : ASSET_NAME;
  const pageAsset = { landingPage: `content/pages/${assetName}.json` };
  const result = await dispatch(fetchPageAssets(pageAsset, true));
  // Keep the page usable if a localized asset has not been published yet.
  if (!result && assetName !== ASSET_NAME) {
    return dispatch(fetchPageAssets({ landingPage: `content/pages/${ASSET_NAME}.json` }, true));
  }
  return result;
};
